module.exports = __webpack_public_path__ + "assets/img/j-bar-with-paddle-holder.a506e1e4.png";